export const SET_SYSTEM_PARAMETERS_DATA = 'SET_SYSTEM_PARAMETERS_DATA';
export const UPDATE_SYSTEM_PARAMETER_DATA = 'UPDATE_SYSTEM_PARAMETER_DATA';
export const CLEAR_SYSTEM_PARAMETERS_DATA = 'CLEAR_SYSTEM_PARAMETERS_DATA';

export const setSystemParametersDataAction = data => ({ type: SET_SYSTEM_PARAMETERS_DATA, data });
export const updateSystemParameterDataAction = (key, data)  => ({ type: UPDATE_SYSTEM_PARAMETER_DATA, key, data });
export const clearSystemParametersDataAction = () => ({type: CLEAR_SYSTEM_PARAMETERS_DATA});